/** Teknisyen sipariş oluşturma yetkisi — backend enum ile uyumlu */
export const ORDER_CREATION_PERMISSION_OPTIONS = [
  { value: 'none', label: 'Sipariş Veremez', badgeVariant: 'none' },
  { value: 'approved', label: 'Onaylı sipariş verebilir', badgeVariant: 'approved' },
  { value: 'direct', label: 'Direkt sipariş verebilir', badgeVariant: 'direct' },
];

export const ORDER_CREATION_PERMISSION_DEFAULT = 'none';

export const getOrderCreationPermissionLabel = (value) => {
  const found = ORDER_CREATION_PERMISSION_OPTIONS.find((o) => o.value === value);
  return found ? found.label : ORDER_CREATION_PERMISSION_OPTIONS[0].label;
};

export const getOrderCreationPermissionBadgeVariant = (value) => {
  const found = ORDER_CREATION_PERMISSION_OPTIONS.find((o) => o.value === value);
  return found ? found.badgeVariant : ORDER_CREATION_PERMISSION_OPTIONS[0].badgeVariant;
};
